module.exports = __webpack_public_path__ + "img/review-us-on-trustpilot.86401b28.png";